import { render, staticRenderFns } from "./EmailGateway.vue?vue&type=template&id=8f399730"
import script from "./EmailGateway.vue?vue&type=script&lang=js"
export * from "./EmailGateway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports